export default "__VITE_ASSET__DvFzru6y__"